module.exports = __webpack_public_path__ + "fonts/fontello.d91b5b9.woff2";